import { Breadcrumbs, Typography, Link, Stack, TablePagination } from "@mui/material";
import { StyledDataGrid } from "../../../../../common/components/styled_data_grid";
import { useMemo } from "react";

import RefreshButton from "../../../../../common/components/refresh_button";
import AlertError from "../../../../../common/components/alert_error";
import { useGestaoTreinamentosListaViewModel } from "../../viewModels/gestao_treinamentos_lista_view_model";
import { Header } from "./components/header";
import { LegendaModal } from "./components/legenda_modal";
import { GenerateFuncionariosTercerizacaoColumns } from "./columns";
import DeleteDialog from "../../../../../common/components/delete_dialog";


export const GestaoTreinamentosTercLista = () => {
  const viewModel = useGestaoTreinamentosListaViewModel();

  const columnsDefinition = useMemo(() => {
    return GenerateFuncionariosTercerizacaoColumns({
      onActionEditar: viewModel.handleGestaoTreinamentosCadastroOpenState,
      onActionDeletar: viewModel.handleDeleteModalOpenState
    });
  }, [viewModel.handleDeleteModalOpenState, viewModel.handleGestaoTreinamentosCadastroOpenState]);

  return (
    <>
      <div className="PAGE flex w-full gap-2 flex-col py-2 px-4 mb-20">
        <Breadcrumbs aria-label="breadcrumb" className="cursor-pointer">
          <Link underline="hover" color="inherit">
            Terceirizacao
          </Link>
          <Typography className="text-primary-green">
            Gestão de Treinamentos
          </Typography>
        </Breadcrumbs>

        <div className="div flex justify-between items-center flex-col md:flex-row gap-6 md:gap-0">
          <div className="flex gap-2 items-center w-full">
            <h1 className="text-3xl font-medium text-black dark:text-white">Gestão de Treinamentos</h1>
            <RefreshButton onClick={viewModel.handleReloadPage} />
          </div>
        </div>

        {
          viewModel.errorMessage !== undefined
            ? (
              <div className="w-full">
                <AlertError
                  messageErro={viewModel.errorMessage}
                  onTryAgain={viewModel.handleReloadPage} />
              </div>
            ) : (
              <>
                <Header
                  NomePesquisa={viewModel.filters.NomePesquisa}
                  FornecedorPesquisa={viewModel.filters.FornecedorPesquisa}
                  ContratoPesquisa={viewModel.filters.ContratoPesquisa}
                  StatusPesquisa={viewModel.filters.StatusPesquisa}
                  centroDeCusto={viewModel.filters.centroDeCusto}
                  centroDeCustoLista={viewModel.filters.centroDeCustoLista ?? []}
                  AvaliacoesPesquisa={viewModel.filters.AvaliacoesPesquisa}
                  CargoPesquisa={viewModel.filters.CargoPesquisa}
                  DocumentosPesquisa={viewModel.filters.DocumentosPesquisa}
                  handleCargoChange={viewModel.handleCargoChange}
                  handleDocumentosPesquisa={viewModel.handleDocumetosPesquisaChange}
                  handleAvaliacoesPesquisa={viewModel.handleAvaliacaoPesquisaChange}
                  onClearFilters={viewModel.handleClearFilters}
                  handleNomeCampoChange={viewModel.handleNomePesquisaChange}
                  handleCentroDeCusto={viewModel.handleCentroDeCustoChange}
                  handleFornecedorChange={viewModel.handleFornecedorChange}
                  handleContratoChange={viewModel.handleContratoChange}
                  handleStatusPesquisa={viewModel.handleStatusPesquisaChange} />

                <Stack spacing={0}>
                  <div className="w-full flex flex-row justify-between items-end">
                    <div className="flex flex-col justify-end my-2">
                      <span
                        className="text-[#009C4E] bg-transparent border border-[#009C4E] px-2 py-1 text-sm rounded rounded-base font-semibold cursor-pointer"
                        onClick={() => viewModel.handleShowLegenda(true)}>
                        Legenda
                      </span>
                    </div>


                    <div className="flex flex-col justify-between flex-1">
                      <TablePagination
                        component="div"
                        count={viewModel.pagination.totalItems}
                        page={viewModel.pagination.page - 1}
                        onPageChange={(_, p) => viewModel.handlePageChange(p)}
                        rowsPerPageOptions={[10, 25, 50, 100]}
                        rowsPerPage={viewModel.pagination.rowsPerPage}
                        onRowsPerPageChange={(e) => viewModel.handleRowsPerPageChange(parseInt(e.target.value))} />
                    </div>
                  </div>

                  <StyledDataGrid
                    tableName="gestao_treinamentos_lista"
                    disableColumnMenu={false}
                    getRowId={(row) => row.IdFuncionarioTerc}
                    columns={columnsDefinition}
                    loading={viewModel.loading}
                    rows={viewModel.funcionarios}
                    rowCount={viewModel.funcionarios.length}
                    pageSizeOptions={[10, 25, 50, 100]}
                    pinnedColumns={{
                      right: ['IdFuncionarioTerc'],
                    }}
                    autoHeight={true}
                    textSize="medio"
                    getRowHeight={() => "auto"}
                    paginationMode="server"
                    paginationModel={{
                      page: viewModel.pagination.page,
                      pageSize: viewModel.pagination.rowsPerPage,
                    }} />

                  <TablePagination
                    component="div"
                    count={viewModel.pagination.totalItems}
                    page={viewModel.pagination.page - 1}
                    onPageChange={(_, p) => viewModel.handlePageChange(p)}
                    rowsPerPageOptions={[10, 25, 50, 100]}
                    rowsPerPage={viewModel.pagination.rowsPerPage}
                    onRowsPerPageChange={(e) => viewModel.handleRowsPerPageChange(parseInt(e.target.value))} />

                </Stack>
              </>
            )
        }


        {/* Modals */}

        <LegendaModal
          open={viewModel.showLegenda}
          onClose={() => viewModel.handleShowLegenda(false)}
        />
        <DeleteDialog
          open={viewModel.deleteModal}
          saving={viewModel.saving}
          onClose={() => viewModel.handleDeleteModalOpenState(null, false)}
          title={`Você realmente deseja excluir o funcionário ${viewModel.selectedFuncionario?.Nome}?`}
          onDelete={viewModel.handleDeleteConfirma} />

      </div>
    </>
  )
}